module.exports = "/images/icon-tooltip-info.svg?5c9715aeef612838aaddcb759d13a007";